<template>
  <div>
    <div class="dx-fieldset">
      <dx-tree-list id="tasks"
                    ref="tasks"
                    :data-source="dashdata.list"
                    :show-borders="true"
                    :column-auto-width="true"
                    :word-wrap-enabled="true"
                    :on-cell-prepared="onCellPrepared"
                    :expanded-row-keys="expandedRowKeys"
                    :selected-row-keys="selectedRowKeys"
                    :show-column-lines="false"
                    :show-row-lines="true"
                    :focused-row-enabled="true"
                    :hint="$t('Webportal.Porsche.ResulttableTooltip')"
                    @rowClick="onRowClick"
                    @rowPrepared="onRowPrepared"
                    :row-alternation-enabled="true"
                    key-expr="KpiCode"
                    parent-id-expr="KpiCodeParent">
        <dx-header-filter :visible="false"/>

        <dx-column  data-field="SortIndex"
                    :visible="false"
                    :sortIndex="0"
                    sortOrder="desc" />

        <dx-column  :width="260"
                    data-field="KpiName"
                    :caption="$t('Webportal.Dimensions')" />

        <dx-column  v-for="index in waveCounter" :key="index"
                    :width="150"
                    :data-field="getSurveyWave(index)"
                    :visible="true"
                    :caption="getWaveName(index)"
                    cell-template="waveOverviewTemplate">
        </dx-column>

        <dx-column  :allow-sorting="false"
                    :min-width="250"
                    data-field="SurveyWave"
                    :caption="'%-' + $t('Webportal.Points')"
                    cell-template="waveTemplate">
        </dx-column>

        <wave-overview-cell slot="waveOverviewTemplate" slot-scope="options" :cell-data="options.data"/>
        <wave-name-cell slot="waveNameTemplate" slot-scope="options" :cell-data="options.data" />
        <wave-cell slot="waveTemplate" slot-scope="options" :cell-data="options.data" />
        <diff-cell slot="diffTemplate" slot-scope="options" :cell-data="options.data" />
        <result-cell slot="resultTemplate" slot-scope="options" :cell-data="options.data" />
        <basis-cell slot="basisCellTemplate" slot-scope="options" :cell-data="options.data" />

      </dx-tree-list>
    </div>

    <foot :dashdata="dashdata" />
  </div>
</template>

<script>

import {
  DxTreeList,
  DxColumn,
  DxHeaderFilter,
  DxSearchPanel,
  DxSelection,
  DxSummary,
  DxLookup,
} from 'devextreme-vue/tree-list';

import { DxTitle } from 'devextreme-vue/chart';
import WaveCell from './WaveCell.vue';
import WaveNameCell from './WaveNameCell.vue';
import WaveOverviewCell from './WaveOverviewCell.vue';
import DiffCell from './DiffCell.vue';
import ResultCell from './ResultCell.vue';
import BasisCell from './BasisCell.vue';
import scale from './Scale';
import PorscheWaves from '@/mixins/PorscheWaves';
import foot from './Foot.vue';

export default {
  name: 'ResultTable',

  components: {
    DxTreeList,
    DxColumn,
    DxHeaderFilter,
    DxSearchPanel,
    DxSelection,
    DxSummary,
    DxLookup,
    DxTitle,
    WaveCell,
    WaveNameCell,
    WaveOverviewCell,
    DiffCell,
    ResultCell,
    BasisCell,
    scale,
    foot
  },

  props: {
    dashdata: { type: Object, default: null }
  },

  created() {
    // console.log('ResultTable - created - data: ' + JSON.stringify(this.dashdata));
    if (this.dashdata && this.dashdata.list && this.dashdata.list.length > 0) {
      this.waveCounter = this.dashdata.list[0].SurveyWave.length;
      //console.log("ResultTable - created - Wavecounter: " + this.waveCounter);
    }
  },

  data() {
    return {
      expandedRowKeys: [],
      selectedRowKeys: [],
      waveCounter: 0
    };
  },

  methods: {
    getEntityName() {
      if (this.dashdata.customHeader) {
        return ' - ' + this.dashdata.customHeader;
      }
      return '';
    },

    getPreviousWave() {
      let name = '';
      if (this.dashdata.wavenames.length < 2) {
        name = 'N/A';
      } else {
        if (!_.isEmpty(this.dashdata.OverallByWave[0])) {
          name = this.getPreviousWaveName(this.dashdata.OverallByWave[0]);
        }
      }
      return this.$t('Webportal.PreviousWave') + ': ' + name;
    },

    getCurrentWave() {
      let name = '';
      if (!_.isEmpty(this.dashdata.OverallByWave[0])) {
        name = this.getCurrentWaveName(this.dashdata.OverallByWave[0]);
      }
      return this.$t('Webportal.CurrentWave') + ': ' + name;
    },

    getWaveName(index) {

      // the v-for loop will return index based on 1,
      // so we have to switch index based on 0
      index--;

      if (this.dashdata && this.dashdata.list && this.dashdata.list.length > 0 && this.dashdata.list[0].SurveyWave && this.dashdata.list[0].SurveyWave.length > index) {
        return this.dashdata.list[0].SurveyWave[index].Name;
      } else {
        return "Wave";
      }
    },

    getSurveyWave(index) {
      return "SurveyWave";
    },

    onRowPrepared: function(e) {
      if (e.level > 0 || e.rowType === 'header' || e.key === '00. Overall') {
        return;
      }
    },

    onRowClick: function(e) {
      // Prevent the small triangle from beeing handled twice
      if (e.event.target.parentElement.classList.contains("dx-treelist-expanded") || e.event.target.parentElement.classList.contains("dx-treelist-collapsed")) {
        return;
      }

      var treelist = this.$refs["tasks"].instance;
      if (treelist.isRowExpanded(e.key)) {
          treelist.collapseRow(e.key);
      } else {
          treelist.expandRow(e.key);
      }
    },

    onCellPrepared: function(e){
      if(e.rowType == 'header') {
        e.cellElement.style.fontWeight = 'bold';
        e.cellElement.style.color = '#EEE';
        e.cellElement.style.backgroundColor = '#737178';
      } else if (e.data) {
        // add column index info to the data, so that the column templates
        // can operate with it
        e.data.CurrentColIndex = e.columnIndex;
      }
    }
  },
};

</script>

<style scoped>

.card-body {
  padding: 0px;  margin-bottom: 0.5rem;
}

.dx-fieldset {
  margin: 1rem;
}

#tasks {
    min-height: 150px;
}

#tasks .dx-treelist-rowsview td {
    vertical-align: middle;
}

.pitem {
  text-align: center;
  height: 40px;
  /* width: 300px; */
  margin-left: 347px;
  margin-right: 228px;
}
</style>
